"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _v = _interopRequireDefault(require("uuid/v4"));

var _errors = require("../errors/errors");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Asset =
/*#__PURE__*/
function () {
  function Asset(assetJSON, value) {
    var id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, _v["default"])();

    _classCallCheck(this, Asset);

    _defineProperty(this, "assetJSON", void 0);

    _defineProperty(this, "totalValue", void 0);

    _defineProperty(this, "valueRemaining", void 0);

    _defineProperty(this, "id", void 0);

    this.assetJSON = assetJSON;
    this.totalValue = value;
    this.valueRemaining = value;
    this.id = id;
  }

  _createClass(Asset, null, [{
    key: "generateFromAssetObject",
    value: function generateFromAssetObject(assetObj) {
      var assetValue = _lodash["default"].get(assetObj, 'value') || 0;
      var portionOwned = _lodash["default"].get(assetObj, 'portionOwned') || 100;

      var id = _lodash["default"].get(assetObj, 'id');

      if (assetValue != null) {
        return new Asset(assetObj, assetValue * (portionOwned / 100), id);
      }

      throw new _errors.ParameterError({
        message: 'Could not find a value in asset object'
      });
    }
  }]);

  return Asset;
}();

exports["default"] = Asset;